import React, {useEffect, useState} from "react";
import "./style.scss"
import {
    cancelPackage1,
    cancelPackage2,
    cancelPackage3,
    cancelPackage4,
    cancelPackage5,
    cancelService1,
    cancelService2,
    cancelService3,
    cancelService4,
    cancelService5,
    cancelService6,
    checkRemainingTraffic1,
    checkRemainingTraffic2,
    checkRemainingTraffic3,
    checkScope1,
    checkScope2,
    checkScope3,
    checkScope4,
    checkScope5,
    enCancelPackage1,
    enCancelPackage2,
    enCancelPackage3,
    enCancelPackage4,
    enCancelPackage5,
    enCancelService1,
    enCancelService2,
    enCancelService3,
    enCancelService4,
    enCancelService5,
    enCancelService6,
    enCheckRemainingTraffic1,
    enCheckRemainingTraffic2,
    enCheckRemainingTraffic3,
    enCheckScope1,
    enCheckScope2,
    enCheckScope3,
    enCheckScope4,
    enCheckScope5,
    enDataRoamingIphone1,
    enDataRoamingIphone2,
    enDataRoamingIphone3,
    enDataRoamingIphone4,
    enDataRoamingIphone5,
    enDataRoamingIphone6,
    enDataRoamingOther1,
    enDataRoamingOther2,
    enDataRoamingOther3,
    enDataRoamingOther4,
    enDataRoamingOther5,
    enDataRoamingOther6,
    enDataRoamingOther7,
    viDataRoamingIphone1,
    viDataRoamingIphone2,
    viDataRoamingIphone3,
    viDataRoamingIphone4,
    viDataRoamingIphone5,
    viDataRoamingIphone6,
    viDataRoamingOther1,
    viDataRoamingOther2,
    viDataRoamingOther3,
    viDataRoamingOther4,
    viDataRoamingOther5,
    viDataRoamingOther6,
    viDataRoamingOther7
} from "../../../assets/imgs/QrCodeMyVnptVer2";
import Swiper from "react-id-swiper";
import {useLocation} from "react-router-dom";
import en from "./locales/en";
import vi from "./locales/vi";
import {Loading} from "../../../components";

const Instruction = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [listInstruction, setListInstruction] = useState([]);
    const [isIphone, setIsIphone] = useState(true);
    const useQuery = new URLSearchParams(useLocation().search);
    const [type, setType] = useState(useQuery.get("type") || "1");
    const checkLanguage = useQuery.get("language");
    const language = (checkLanguage === 'en') ? en : vi;
    console.log("type=", type);

    useEffect(() => {
        setListInstruction(getInstruction(type, language, checkLanguage));
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const container = document.querySelectorAll(".text-description");
        container.forEach((el) => {
            const clickable = el.querySelector(".clickable-redirect-type-2");
            if (clickable) {
                clickable.addEventListener("click", () => {
                    setType("2");
                    setListInstruction(getInstruction("2", language, checkLanguage));
                });
            }
        });

        // return () => {
        //     container.forEach((el) => {
        //         const clickable = el.querySelector(".clickable-redirect-type-2");
        //         if (clickable) {
        //             clickable.removeEventListener("click", () => {
        //                 setType("2");
        //                 setListInstruction(instruction2);
        //             });
        //         }
        //     });
        // };
    });

    const defaultParamsInstruction = {
        slidesPerView: 4,
        spaceBetween: 32,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        scrollbar: {},
        on: {
            // slideChange: () => {
            //     if (swiperRef.current && swiperRef.current.swiper) {
            //         setIsBeginning(swiperRef.current.swiper.isBeginning);
            //         setIsEnd(swiperRef.current.swiper.isEnd);
            //     }
            // },
        },
        breakpoints: {
            290: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            370: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 4,
            },
        }
    };

    const getInstruction = (type, language, checkLanguage) => {
        switch (type) {
            case "1":
                return {
                    headerText: language.HEADER_TEXT_DATA_ROAMING,
                    type: 1,
                    steps: [
                        {
                            image: checkLanguage === "en" ? enDataRoamingIphone1 : viDataRoamingIphone1,
                            title: language.TITLE_DATA_ROAMING_1,
                            desc: language.DESC_DATA_ROAMING_1
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingIphone2 : viDataRoamingIphone2,
                            title: language.TITLE_DATA_ROAMING_2,
                            desc: language.DESC_DATA_ROAMING_2
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingIphone3 : viDataRoamingIphone3,
                            title: language.TITLE_DATA_ROAMING_3,
                            desc: language.DESC_DATA_ROAMING_3
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingIphone4 : viDataRoamingIphone4,
                            title: language.TITLE_DATA_ROAMING_4,
                            desc: language.DESC_DATA_ROAMING_4
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingIphone5 : viDataRoamingIphone5,
                            title: language.TITLE_DATA_ROAMING_5,
                            desc: language.DESC_DATA_ROAMING_5
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingIphone6 : viDataRoamingIphone6,
                            title: language.TITLE_DATA_ROAMING_6,
                            desc: language.DESC_DATA_ROAMING_6
                        }
                    ]
                };
            case "2":
                return {
                    headerText: language.HEADER_TEXT_SCOPE,
                    type: 2,
                    steps: [
                        {
                            image: checkLanguage === "en" ? enCheckScope1 : checkScope1,
                            title: language.TITLE_SCOPE_1,
                            desc: language.DESC_SCOPE_1
                        },
                        {
                            image: checkLanguage === "en" ? enCheckScope2 : checkScope2,
                            title: language.TITLE_SCOPE_2,
                            desc: language.DESC_SCOPE_2
                        },
                        {
                            image: checkLanguage === "en" ? enCheckScope3 : checkScope3,
                            title: language.TITLE_SCOPE_3,
                            desc: language.DESC_SCOPE_3
                        },
                        {
                            image: checkLanguage === "en" ? enCheckScope4 : checkScope4,
                            title: language.TITLE_SCOPE_4,
                            desc: language.DESC_SCOPE_4
                        },
                        {
                            image: checkLanguage === "en" ? enCheckScope5 : checkScope5,
                            title: language.TITLE_SCOPE_5,
                            desc: language.DESC_SCOPE_5
                        }
                    ]
                };
            case "3":
                return {
                    headerText: language.HEADER_TEXT_REMAINING_TRAFFIC,
                    type: 3,
                    steps: [
                        {
                            image: checkLanguage === "en" ? enCheckRemainingTraffic1 : checkRemainingTraffic1,
                            title: language.TITLE_REMAINING_TRAFFIC_1,
                            desc: language.DESC_REMAINING_TRAFFIC_1
                        },
                        {
                            image: checkLanguage === "en" ? enCheckRemainingTraffic2 : checkRemainingTraffic2,
                            title: language.TITLE_REMAINING_TRAFFIC_2,
                            desc: language.DESC_REMAINING_TRAFFIC_2
                        },
                        {
                            image: checkLanguage === "en" ? enCheckRemainingTraffic3 : checkRemainingTraffic3,
                            title: language.TITLE_REMAINING_TRAFFIC_3,
                            desc: language.DESC_REMAINING_TRAFFIC_3
                        }
                    ]
                };
            case "4":
                return {
                    headerText: language.HEADER_TEXT_CANCEL_SERVICE,
                    type: 4,
                    steps: [
                        {
                            image: checkLanguage === "en" ? enCancelService1 : cancelService1,
                            title: language.TITLE_CANCEL_SERVICE_1,
                            desc: language.DESC_CANCEL_SERVICE_1
                        },
                        {
                            image: checkLanguage === "en" ? enCancelService2 : cancelService2,
                            title: language.TITLE_CANCEL_SERVICE_2,
                            desc: language.DESC_CANCEL_SERVICE_2
                        },
                        {
                            image: checkLanguage === "en" ? enCancelService3 : cancelService3,
                            title: language.TITLE_CANCEL_SERVICE_2,
                            desc: language.DESC_CANCEL_SERVICE_3
                        },
                        {
                            image: checkLanguage === "en" ? enCancelService4 : cancelService4,
                            title: language.TITLE_CANCEL_SERVICE_2,
                            desc: language.DESC_CANCEL_SERVICE_4
                        },
                        {
                            image: checkLanguage === "en" ? enCancelService5 : cancelService5,
                            title: language.TITLE_CANCEL_SERVICE_2,
                            desc: language.DESC_CANCEL_SERVICE_5
                        },
                        {
                            image: checkLanguage === "en" ? enCancelService6 : cancelService6,
                            title: language.TITLE_CANCEL_SERVICE_2,
                            desc: language.DESC_CANCEL_SERVICE_6
                        }
                    ]
                }
            case "5":
                return {
                    headerText: language.HEADER_TEXT_CANCEL_PACKAGE,
                    type: 5,
                    steps: [
                        {
                            image: checkLanguage === "en" ? enCancelPackage1 : cancelPackage1,
                            title: language.TITLE_CANCEL_PACKAGE_1,
                            desc: language.DESC_CANCEL_PACKAGE_1
                        },
                        {
                            image: checkLanguage === "en" ? enCancelPackage2 : cancelPackage2,
                            title: language.TITLE_CANCEL_PACKAGE_2,
                            desc: language.DESC_CANCEL_PACKAGE_2
                        },
                        {
                            image: checkLanguage === "en" ? enCancelPackage3 : cancelPackage3,
                            title: language.TITLE_CANCEL_PACKAGE_3,
                            desc: language.DESC_CANCEL_PACKAGE_3
                        },
                        {
                            image: checkLanguage === "en" ? enCancelPackage4 : cancelPackage4,
                            title: language.TITLE_CANCEL_PACKAGE_4,
                            desc: language.DESC_CANCEL_PACKAGE_4
                        },
                        {
                            image: checkLanguage === "en" ? enCancelPackage5 : cancelPackage5,
                            title: language.TITLE_CANCEL_PACKAGE_5,
                            desc: language.DESC_CANCEL_PACKAGE_5
                        }
                    ]
                };
            case "6":
                return {
                    headerText: language.HEADER_TEXT_DATA_ROAMING,
                    type: 1,
                    steps: [
                        {
                            image: checkLanguage === "en" ? enDataRoamingOther1 : viDataRoamingOther1,
                            title: language.TITLE_DATA_ROAMING_OTHER_1,
                            desc: language.DESC_DATA_ROAMING_OTHER_1
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingOther2 : viDataRoamingOther2,
                            title: language.TITLE_DATA_ROAMING_OTHER_2,
                            desc: language.DESC_DATA_ROAMING_OTHER_2
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingOther3 : viDataRoamingOther3,
                            title: language.TITLE_DATA_ROAMING_OTHER_3,
                            desc: language.DESC_DATA_ROAMING_OTHER_3
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingOther4 : viDataRoamingOther4,
                            title: language.TITLE_DATA_ROAMING_OTHER_4,
                            desc: language.DESC_DATA_ROAMING_OTHER_4
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingOther5 : viDataRoamingOther5,
                            title: language.TITLE_DATA_ROAMING_OTHER_5,
                            desc: language.DESC_DATA_ROAMING_OTHER_5
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingOther6 : viDataRoamingOther6,
                            title: language.TITLE_DATA_ROAMING_OTHER_6,
                            desc: language.DESC_DATA_ROAMING_OTHER_6
                        },
                        {
                            image: checkLanguage === "en" ? enDataRoamingOther7 : viDataRoamingOther7,
                            title: language.TITLE_DATA_ROAMING_OTHER_7,
                            desc: language.DESC_DATA_ROAMING_OTHER_7
                        }
                    ]
                };
        }
    };

    const handleSelectDevice = (chooseIphone) => {
        setListInstruction(chooseIphone ? getInstruction("1", language, checkLanguage) : getInstruction("6", language, checkLanguage));
        setIsIphone(chooseIphone);
    }

    return (
        <div id="roaming-instruction">
            <div className="wrapper">
                {
                    isLoading ? (
                        <Loading/>
                    ) : (
                        <>
                            <div>
                                <div className="text-header">
                                    {listInstruction?.headerText}
                                </div>
                                {
                                    type === "1" &&
                                    <div className="select-devices">
                                        <div className={`devices ${isIphone ? "active" : ""}`}
                                             onClick={() => handleSelectDevice(true)}>iPhone
                                        </div>
                                        <div className={`devices ${isIphone ? "" : "active"}`}
                                             onClick={() => handleSelectDevice(false)}>{language.TEXT_OTHER_DEVICES}
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="swiper-ladding-pages">
                                {!isLoading && (
                                    <Swiper key={listInstruction?.steps?.length} {...defaultParamsInstruction} >
                                        {listInstruction?.steps?.map((item, index) => (
                                            <div className="swiper-steps" key={index}>
                                                <div className="image">
                                                    <img
                                                        src={item?.image}
                                                        loading="lazy"
                                                        alt=""
                                                        onLoad={() => console.log("Image loaded")}
                                                        style={{
                                                            opacity: isLoading ? 0 : 1,
                                                            transition: "opacity 0.3s ease-in-out"
                                                        }}
                                                    />
                                                </div>
                                                <div className="text-title">{item?.title}</div>
                                                <div className="text-description"
                                                     dangerouslySetInnerHTML={{__html: item?.desc}}/>
                                            </div>
                                        ))}
                                    </Swiper>
                                )}
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    );
}


export default React.memo(Instruction);